import ServiceBase from './serviceBase';
import { MainContextDto } from './types/Main';

class MainService extends ServiceBase {
  getContext = async (): Promise<MainContextDto> => this.get<MainContextDto>('main/context');
}

const mainService = new MainService();
export default mainService;
